import { ENV, NODE_ENV } from 'config/env'

export const isDevEnv = NODE_ENV === ENV.DEV
export const isProdEnv = NODE_ENV === ENV.PROD
